import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { FILE_DELETE_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class FileDeleteRequest extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  url = FILE_DELETE_URL;

  body = {};

  constructor(fileId) {
    super();
    this.fileId = fileId;
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => getCurrentUserParameters(this.url.replace("%1", this.fileId));

  getBody = () => this.body;
}
